import { connect } from "react-redux";
import React, { Component } from "react";
import { Bubble } from "ctia-ui";
import FormElement from "components/FormElement";
import { handleInputChange, setValue } from "actions/request";
import { hasStringValue } from "helpers/RequestHelper";
import * as formHelper from "helpers/FormHelper";
import * as modelHelper from "helpers/ModelHelper";
import { getBSCPackRequests } from "actions/battery/blcRequest";

class RequestInitialModelBLC extends Component {
  state = { touched: false, fieldName: "existedModel" };

  componentDidMount() {
    this.setState({
      fieldName: formHelper.defineModelFieldId(this.props.request)
    });
  }

  isValidationRequired = () => {
    return this.props.user.canEditModelname;
  };

  validateModelName() {
    if ((!this.isValidationRequired() || !this.state.touched) && !this.props.user.isStaff) return null;

    return hasStringValue(this.props.request, this.state.fieldName)
      ? null
      : "error";
  }

  onFieldChanged = event => {
    if (!this.state.touched) {
      this.setState({ touched: true });
    }

    if(!this.props.user.isStaff) {
      const model = modelHelper.findExistedModelByName(
        event.target.value,
        this.props.requests.blcModels
      );

      if (model) {
        this.props.handleInputChange(event);
        this.props.setValue("deviceType", model.devicetype);
        this.props.setValue("modelName", event.target.value);
        this.props.setValue("devicemodelid", model.value);
        this.props.getBSCPackRequests(model.value);
      } else {
        console.error("Model for BLC request can't be found.");
      }
    } else {
        this.props.setValue("modelName", event.target.value);
    }

  };

  render() {
    const { requests, request } = this.props;
    const isEditable = this.isValidationRequired();
    const inputType = formHelper.defineEcoModelFieldType(isEditable, request);
    const modelName = formHelper.defineEcoModelName(isEditable, request);
    const { blcModels } = requests || [];

    if (blcModels && blcModels.length === 0) {
      return (
        <Bubble type="danger">
          Please submit an BSC Initial request first in order to submit the BLC
          Initial.
        </Bubble>
      );
    }

    return (
      <FormElement
        id={this.state.fieldName}
        type={inputType}
        label="Model Name/Number"
        value={modelName}
        options={blcModels}
        editable={isEditable}
        onChange={this.onFieldChanged}
        validationState={this.validateModelName()}
        validationMessage={formHelper.emptyMsg}
        customOptions={{
          combobox: false,
          notFoundContent: "Model Name not found"
        }}
        useIdAsValue={false}
      />
    );
  }
}

function mapStateToProps({ app, requests, request, user }) {
  return { app, requests, request, user };
}

export default connect(mapStateToProps, {
  handleInputChange,
  getBSCPackRequests,
  setValue
})(RequestInitialModelBLC);
